import cryptoJs from 'crypto-js'

/**
 * DES
 */

/*
 * message:需要加密的字符串，对象加密需要转成json字符串
 * key： 密钥（加密解密密钥同一个）
 */
export function encryptDes(message, key = 'i8888888') {
  const keyHex = cryptoJs.enc.Utf8.parse(key)
  const option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
  const encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
  // 返回hex格式密文，如需返回base64格式：encrypted.toString()
  //   return encrypted.ciphertext.toString()
  return encrypted.toString()
}

//随机生成指定数量的16进制key
export const generatekey = (num) => {
  let library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let key = ''
  for (const i = 0; i < num; i++) {
    let randomPoz = Math.floor(Math.random() * library.length)
    key += library.substring(randomPoz, randomPoz + 1)
  }
  return key
}

//DES加密
// export const encryptDes = (message, key) => {
//   const keyHex = cryptoJs.enc.Utf8.parse(key)
//   const option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
//   const encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
//   return encrypted.ciphertext.toString()
// }

//DES解密
export const decryptDes = (message, key) => {
  const keyHex = cryptoJs.enc.Utf8.parse(key)
  const decrypted = cryptoJs.DES.decrypt(
    {
      ciphertext: cryptoJs.enc.Hex.parse(message),
    },
    keyHex,
    {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7,
    }
  )
  return decrypted.toString(cryptoJs.enc.Utf8)
}

/**
 * 富文本转换转换
 *
 * @param {Object} html 富文本内容
 */
export function format(html) {
  var GRT = [
    // img 样式
    ['img', 'max-width:100%;height:auto;'],
  ]
  console.log(html)
  for (let i = 0; i < GRT.length; i++) {
    html = html.replace(new RegExp('<' + GRT[i][0] + '>|<' + GRT[i][0] + ' (.*?)>', 'gi'), function (word) {
      // 分析 dom 上是否带有 style=""
      if (word.indexOf('style=') != -1) {
        var regIn = new RegExp('<' + GRT[i][0] + '(.*?)style="(.*?)"(.*?)(/?)>', 'gi')
        return word.replace(regIn, '<' + GRT[i][0] + '$1style="$2 ' + GRT[i][1] + '"$3$4>')
      } else {
        var regIn = new RegExp('<' + GRT[i][0] + '(.*?)(/?)>', 'gi')
        return word.replace(regIn, '<' + GRT[i][0] + '$1 style="' + GRT[i][1] + '$2">')
      }
    })
  }
  return html
}
